// Using "good enough" kebab case - rather than import lodash
export const kebabCase = (str: string) => {
  // Replace non-alphanumeric characters with hyphen
  const cleanStr = str.replace(/[^a-zA-Z0-9]+/g, () => "-");

  // Convert to lowercase
  const lowercaseStr = cleanStr.toLowerCase();

  return lowercaseStr;
};

// 1. Fix links
const aHrefRegDoubleQuotes = /(<a[^>]* )href="(NAV_TO:[^"]*)"([^>]*>)/g;
const aHrefRegSingleQuotes = /(<a[^>]* )href='(NAV_TO:[^']*)'([^>]*>)/g;

export const ATTR_NAME = "data-navto";

export const replaceNavToLinks = (html: string): string => {
  html = html.replace(aHrefRegDoubleQuotes, `$1 ${ATTR_NAME}="$2" href="#" $3`);
  html = html.replace(aHrefRegSingleQuotes, `$1 ${ATTR_NAME}="$2" href="#" $3`);
  return html;
};

// 2. Fix structure
// If a <b> has only a parent <p> then convert it to a <h3> and add an id
export const convertBoldToHeading = (htmlContent: string): string => {
  const el = document.createElement("div");
  el.innerHTML = htmlContent;

  const pElements = el.querySelectorAll("p");

  pElements.forEach((pElement) => {
    const bElement = pElement.querySelector("b");

    const pattern = /^<b>[^\n<>]+<\/b>$/;
    if (bElement && pattern.test(pElement.innerHTML)) {
      const subHeadingText = bElement.textContent;
      if (subHeadingText) {
        const subHeadingId = kebabCase(subHeadingText);
        const h3Element = document.createElement("h3");
        h3Element.id = subHeadingId;
        h3Element.innerHTML = bElement.innerHTML;
        pElement.replaceWith(h3Element);
      }
    }
  });

  return el.innerHTML;
};

// 3. Fix styling
// ArticleBody.styles.ts

export const replaceHtml = (html: string): string => {
  if (!html) return html;
  html = replaceNavToLinks(html);
  html = convertBoldToHeading(html);
  return html;
};

export const scrollToAnchor = (location: { hash: string }) => {
  const anchorValue = location.hash.replace("#", "");
  if (anchorValue !== "") {
    const element = document.getElementById(anchorValue);
    //workaround ensuring DOM had loaded before scrolling
    setTimeout(() => {
      element?.scrollIntoView(true);
    }, 50);
  }
};
